import React from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import DpCard from '../../DynamicPanel/components/card/DpCard';
import { HelpButton } from '../../../components/HelpButton';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '16px',
    flexWrap: 'wrap',
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
  },
  title: {
    fontWeight: 700,
    fontSize: '1.25rem',
    color: '#111827',
  },
}));

export const HomePanel = ({ title, headerAction, helpText, children, style, padding = 3, borderBottom = 'none' }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <DpCard>
      <Box padding={padding} display="flex" flexDirection="column" style={{ borderBottom, height: '100%', position: 'relative', borderRadius: '8px', ...style }}>
        {(title || headerAction) && (
          <Box className={classes.header}>
            {title && (
              <Box className={classes.titleRow}>
                <Typography className={classes.title}>
                  {title}
                </Typography>
                <HelpButton helpText={helpText} tooltipText={t('text.information')}/>
              </Box>
            )}
            {headerAction && (
              <Box>
                {headerAction}
              </Box>
            )}
          </Box>
        )}
        {children}
      </Box>
    </DpCard>
  );
};
